import { Component, DoCheck, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { BrIconComponent } from '../../../shared/ui/icon/icon.component';
import { DensityFeature } from './density-feature';
import { DensitySettingsComponent } from './density-settings.component';

@Component({
  selector: 'app-density-legend',
  standalone: true,
  imports: [CommonModule, FormsModule, MatSelectModule, OverlayModule, BrIconComponent, DensitySettingsComponent],
  templateUrl: './density-legend.component.html',
  styleUrls: ['../../components/map-control.css', './density-legend.component.css'],
})
export class DensityLegendComponent implements DoCheck {
  settingsOpen = false;
  readonly settingsPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom', offsetX: 8 },
    { originX: 'start', originY: 'bottom', overlayX: 'end', overlayY: 'bottom', offsetX: -8 },
  ];
  constructor(public readonly density: DensityFeature, @Inject(DOCUMENT) private readonly document: Document) {}

  ngDoCheck(): void {
    if (!this.density.enabled) this.settingsOpen = false;
  }

  focusSettings(): void {
    queueMicrotask(() => this.document.getElementById('density-settings-panel')?.focus());
  }

  closeSettings(): void {
    this.settingsOpen = false;
    this.document.getElementById('density-settings-trigger')?.focus();
  }

  settingsKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    this.closeSettings();
  }
}
